import { useEffect } from "react";
import logoPrefeitura from "../../../imagens/prefeitura_ouro_preto_logo_1.png";
import { headerConfigMap } from "./HeaderConfig";
import styles from "./HeaderContent.module.css";
import PdfGeneralCondiction from "../../general/PdfGeneralCondition";
import PdfNatureProduction from "../../general/PdfNatureProduction";
import PdfInitialPage from "../../general/PdfInitialPage"

function HeaderContent({
  view,
  distrito,
  menuFilterParams,
  values,
  filterOptions,
  setGeneralConditionsValuesControls,
  imgParams,
}) {
  const config = headerConfigMap[view] || {};
  const { onFilterClick, selectedOption, onSelectChange } = filterOptions;

  const {
    prodAgropecImage,
    mapImage,
    mapImage2,
    imovelImage,
    naturezaImage,
    carroImage,
    energiaImage,
    aguaImage,
    captacaoAguaImage,
    fossaImage,
    lixoImage,
    esgotoImage,
  } = imgParams;

  const {
    setCarroProprioValue,
    setEnergiaEletricaValue,
    setAbastecimentoAguaValue,
    setTipoFossaValue,
    setDescarteLixoValue,
    setDescarteEsgotoValue,
  } = setGeneralConditionsValuesControls;

  const {category, subcategoria, natureza} = menuFilterParams;
  const { areaValues, prodValues, generalConditionValues } = values;
  const {
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  } = generalConditionValues;

  const { areaMin, areaMax } = areaValues;
  const { prodMin, prodMax } = prodValues;

  const {
    title = "Sem Título",
    showBack = false,
    showFilter = false,
    dropdownOptions = [],
    filterTooltip = "Filtrar",
    filterIcon = "filtro-limpo.svg",
    filterHoverIcon = "filtro-limpo_2.svg",
    downloadIcon = "download.svg",
    downloadHoverIcon = "download2.svg",
    downloadTooltip = "Baixar relatório",
  } = config;

 const handleDownload = () => {
   if (areaMin && areaMax && Number(areaMin) > Number(areaMax)) {
     alert("Área mínima não pode ser maior que a máxima.");
     return;
   }

   if (view === "initialPage") {
     PdfInitialPage.gerarRelatorio(
       distrito,
       natureza,
       prodAgropecImage,
       mapImage,
       imovelImage
     );
   } else if (view === "generalCondition") {
     PdfGeneralCondiction.gerarRelatorio(
       distrito,
       category,
       subcategoria,
       natureza,
       carroProprioValue,
       energiaEletricaValue,
       abastecimentoAguaValue,
       tipoFossaValue,
       descarteLixoValue,
       descarteEsgotoValue,
       carroImage,
       energiaImage,
       aguaImage,
       captacaoAguaImage,
       fossaImage,
       lixoImage,
       esgotoImage
     );
   } else if (view === "natureProduction") {
     PdfNatureProduction.gerarRelatorio(
       distrito,
       category,
       subcategoria,
       natureza,
       areaMin,
       areaMax,
       prodMin,
       prodMax,
       naturezaImage,
       mapImage2
     );
   }
 };

  // Quando muda a view, reseta a opção selecionada
  useEffect(() => {
    if (dropdownOptions.length > 0) {
      onSelectChange(dropdownOptions[0]); // Ex: "Todos"
    }
  }, [view, dropdownOptions, onSelectChange]);

  // Manipulador do clique no botão de filtro
  const handleFilterClick = () => {
    setCarroProprioValue(null);
    setEnergiaEletricaValue(null);
    setAbastecimentoAguaValue(null);
    setTipoFossaValue(null);
    setDescarteLixoValue(null);
    setDescarteEsgotoValue(null);
    onSelectChange(dropdownOptions[0]); // Reseta para "Todos"
  };

  return (
    <div className={styles.headerContent}>
      <div className={styles.sectionContainer}>
        {showBack && (
          <div
            className={styles.backButton}
            onClick={() => onFilterClick("initialPage")}
            aria-label="Voltar"
          >
            &#8592;
          </div>
        )}

        <h1 className={styles.title}>{title}</h1>

        {showFilter && (
          <div className={styles.controls}>
            <select
              className={styles.dropdown}
              value={selectedOption}
              onChange={(e) => onSelectChange(e.target.value)}
            >
              {dropdownOptions.map((opt, idx) => (
                <option key={idx} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            <button
              className={styles.pdfButton}
              style={{ backgroundImage: `url(/icones/geral/${downloadIcon})` }}
              aria-label={downloadTooltip}
              title={downloadTooltip}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${downloadHoverIcon})`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${downloadIcon})`;
              }}
              onClick={handleDownload}
            />
            <button
              className={styles.filterButton}
              onClick={handleFilterClick}
              aria-label={filterTooltip}
              title={filterTooltip}
              style={{
                backgroundImage: `url(/icones/geral/${filterIcon})`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${filterHoverIcon})`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundImage = `url(/icones/geral/${filterIcon})`;
              }}
            />
          </div>
        )}

        <img
          src={logoPrefeitura}
          alt="Prefeitura de Ouro Preto"
          className={styles.logo}
        />
      </div>
    </div>
  );
}

export default HeaderContent;
